/* eslint-disable no-unused-vars */
import Swiper, { Navigation, A11y } from 'swiper/core';

Swiper.use([Navigation, A11y]);

const seeAlso = () => {
    const swiper = new Swiper('.swiper-image-gallery', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesVisibility: true,

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
    });
};
seeAlso();
